module.exports = __webpack_public_path__ + "img/index-banner_product_2.f0c2e8f.png";